import gql from 'graphql-tag';

export const GET_SITEINI_ENCRYPTED_LIST = gql`
  {
    siteiniList(encrypted: true) {
      id
      site
      country
      encrypted
      decrypt_key {
        key
        status
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/siteini/listEncrypted.js